import React from "react";
import { motion } from "framer-motion";

/**
 * Lightweight confetti burst: 28 colored dots that fly out from the origin,
 * fade, and land. Framer-motion driven, no external deps. Renders once on
 * mount and self-cleans after ~1.6s.
 */
const COLORS = ["#0F4C3A", "#D97736", "#5C8A78", "#A8C9BB", "#1A1A1A"];
const PARTICLES = 28;

export default function ConfettiBurst({
  duration = 1.4,
  spread = 220,
  className = "",
}) {
  return (
    <div
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
      aria-hidden="true"
      data-testid="onboarding-confetti"
    >
      <div className="absolute left-1/2 top-1/2">
        {Array.from({ length: PARTICLES }).map((_, i) => {
          const angle = (i / PARTICLES) * Math.PI * 2;
          const distance = spread * (0.55 + Math.random() * 0.55);
          const x = Math.cos(angle) * distance;
          const y = Math.sin(angle) * distance - 40; // slight upward bias
          const rot = 120 + Math.random() * 360;
          const size = 6 + Math.round(Math.random() * 4);
          const color = COLORS[i % COLORS.length];
          const delay = Math.random() * 0.08;
          return (
            <motion.span
              key={i}
              initial={{ x: 0, y: 0, opacity: 1, rotate: 0, scale: 0.6 }}
              animate={{ x, y, opacity: 0, rotate: rot, scale: 1 }}
              transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
              style={{
                position: "absolute",
                width: size,
                height: size * 0.4,
                background: color,
                borderRadius: 1,
                left: -size / 2,
                top: -size / 2,
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
